import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, InputNumber } from "antd";
import InputForm from "./InputForm";
import UsuarioFrame from './UsuarioFrame';
import "./Form.css";

const { Item: ItemForm } = Form;

export default class UsuarioSupervisorForm extends Component {
  state = {
    registro: {
      us_idf: '',
      us_usuario_supervisor: '',
      us_usuario_subordinado: '',
    }
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado
      }, () => {
        // this.refs.registro.us_usuario_supervisor.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({
      [id]: value
    });
  };

  onChangeSupervisor = event => {
    const { registro } = this.state;
    registro['us_usuario_supervisor'] = event.us_usuario_supervisor;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['us_usuario_subordinado'] = event.us_usuario_subordinado;
    this.setState(event);
  }


  onOK = () => {
    if ((!this.state.registro.us_usuario_supervisor) || (this.state.registro.us_usuario_supervisor.key === '0') || (this.state.registro.us_usuario_supervisor.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Supervisor', });
      return;
    }
    if ((!this.state.registro.us_usuario_subordinado) || (this.state.registro.us_usuario_subordinado.key === '0') || (this.state.registro.us_usuario_subordinado.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Vendedor', });
      return;
    }

    this.state.registro.us_usuario_supervisor = this.state.registro.us_usuario_supervisor.key;
    this.state.registro.us_usuario_subordinado = this.state.registro.us_usuario_subordinado.key;

    this.props.onSalvarClick(this.state.registro);
  };





  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { us_idf, us_usuario_supervisor, us_usuario_subordinado, us_mes, us_ano, us_valor } = this.state.registro;

    // console.log('UsuarioSupervisorForm: ', this.state);

    return (
      <Modal
        title={us_idf ? "Edição de Supervisor" : "Cadastro de Supervisor"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24}>
              <UsuarioFrame
                label="Supervisor"
                id="us_usuario_supervisor"
                value={us_usuario_supervisor}
                width={"100%"}
                vendedor={1}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                onChange={this.onChangeSupervisor}
                descricaoPrimeiroItem="Selecione um Vendedor"
                disabled={us_idf ? true : false}
              />
            </Col>

            <Col xs={24}>
              <UsuarioFrame
                label="Vendedor"
                id="us_usuario_subordinado"
                value={us_usuario_subordinado}
                width={"100%"}
                vendedor={1}
                todasEmpresas={this.state.usuario ? this.state.usuario.emp_codigo : 999999}
                onChange={this.onChangeVendedor}
                descricaoPrimeiroItem="Selecione um Vendedor"
                disabled={us_idf ? true : false}
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioSupervisorForm.js